import React, { Component } from 'react'
import './styles.scss'

interface IItemProps {
    checked: boolean
    onClick: () => void
}

class Switcher extends Component<IItemProps> {
    public onClickHandler = () => {
        this.props.onClick()
    }

    public render() {
        const { checked } = this.props

        return (
            <div className="switherContainer" onClick={this.onClickHandler} style={{justifyContent: `${!checked ? 'flex-start' : 'flex-end'}`}}>
                <div className='switherPointer' style={{backgroundColor: `${!checked ? '#C7C7C7' : '#64B5F5'}`}} />
            </div>
        )
    }
}

export default Switcher